
// Vivi's assistant ID - used as default when no preference is set
export const DEFAULT_ASSISTANT_ID = 'a81b2407-c085-40f7-9080-76df8ca60a1c'; // Vivi's ID
